module.exports = __webpack_public_path__ + "static/media/h5备份 9.55549248.jpg";